// Convert relative /api/uploads/... paths to full URL; leave absolute URLs alone.
export function resolveImageUrl(url) {
  if (!url) return "";
  if (/^https?:\/\//i.test(url) || url.startsWith("data:")) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
}

// Build tel: link from phone (prefer phone_tel if provided, else strip phone)
export function telHref(phone_tel, phone) {
  if (phone_tel) return `tel:${phone_tel}`;
  if (phone) return `tel:${phone.replace(/[^\d+]/g, "")}`;
  return "tel:";
}
